<template>
  <div class="file-wrapper">
    <div v-if="!error" class="md-layout align-center">
      <div class>
        <a v-if="uploaded" :href="uri" target="_blank">{{ dataProps.link }}</a>
        <span v-else>
          {{ dataProps.link }}
          <md-progress-spinner class="md-accent" :md-diameter="30" md-mode="indeterminate"></md-progress-spinner>
        </span>
      </div>
      <div class>
        <md-button v-if="!noDelete" @click="$emit('delete')" class="md-icon-button">
          <md-icon>close</md-icon>
        </md-button>
      </div>
    </div>
    <div v-if="error" class="md-layout align-left">
      <div data-drupal-messages class="messages__wrapper layout-container">
        <div class="messages messages--error file-error">
          <ul class="messages__list">
            <li
              class="messages__item"
            >The selected file {{ dataProps.name}} cannot be uploaded. {{ errorMessage }}</li>
          </ul>
          <md-button @click="$emit('upload-file-fail')" class="md-icon-button">
            <md-icon>close</md-icon>
          </md-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import contentDisposition from "content-disposition";

export default {
  name: "FbFileViewFile",
  props: ["dataProps", "cleanError", "uploadUrl", "no-delete"],
  data() {
    return {
      fileurl:
        this.uploadUrl ||
        "/jsonapi/activity_submission/activity_submission/attached_files",
      error: false,
      errorMessage: "",
      token: "",
      uuid: this.dataProps.uuid || "",
      uri: this.dataProps.uri || "",
      name: "",
      uploaded: this.dataProps.uuid != "",
    };
  },
  mounted() {
    if (
      this.dataProps.buffer &&
      this.dataProps.buffer.byteLength &&
      this.dataProps.name
    ) {
      this.getToken().then(() => {
        this.uploadFile(this.dataProps.buffer, this.dataProps.link);
      });
    }
  },
  methods: {
    uploadFile(buffer, name) {
      let fetch_headers = new Headers();
      fetch_headers.append("Content-Type", "application/octet-stream");
      fetch_headers.append("X-CSRF-Token", this.token);
      fetch_headers.append(
        "Content-Disposition",
        contentDisposition(name, { type: "file" })
      );
      return fetch(this.fileurl, {
        credentials: "include",
        method: "POST",
        headers: fetch_headers,
        body: buffer,
      })
        .then((response) => {
          return response.json();
        })
        .then((json) => {
          this.errorMessage = "";
          if (json.errors && json.errors.length) {
            this.uploaded = true;
            this.error = true;
            let errorMessage = json.errors[0].detail.split(/\n/);
            if (
              errorMessage[1] &&
              errorMessage[1].match(/following extensions are allowed/)
            ) {
              let extensionsList = errorMessage[1].match(
                /following extensions are allowed:(.+)\./
              );
              this.errorMessage =
                extensionsList && extensionsList[1]
                  ? "Only files with the following extensions are allowed: " +
                    extensionsList[1]
                  : "";
            }
            // setTimeout(() => {
            //   this.$emit('upload-file-fail');
            // }, 3000)
            this.$emit("update-error", false);
            return;
          }
          this.uuid = json.data.id;
          this.uri = json.data.attributes.uri.url;
          this.name = json.data.attributes.filename;
          this.uploaded = true;
          this.$emit("upload-file", {
            uri: this.uri,
            name: this.name,
            uuid: this.uuid,
          });
        })
        .catch((error) => {
          this.uploaded = true;
          this.error = true;
          this.errorMessage = "";
          this.$emit("update-error", false);
          // setTimeout(() => {
          //   this.$emit('upload-file-fail');
          // }, 3000)
        });
    },
    getToken() {
      return fetch("/session/token?t=" + Date.now(), {
        credentials: "include",
      })
        .then((response) => {
          return response.text();
        })
        .then((text) => {
          this.token = text;
        });
    },
  },
  watch: {
    cleanError(val) {
      if (val == true && this.error) {
        this.$emit("upload-file-fail");
      }
    },
  },
};
</script>

<style lang="scss">
.messages--error.file-error {
  padding-right: 50px;
  position: relative;
  margin-top: 0;
  .md-button {
    position: absolute;
    top: 50%;
    margin-top: -20px;
    right: -6px;
  }
}
</style>